import { queryOptions } from '@tanstack/react-query';
import { QueryClient, useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { DEMARRAGE_KEY } from '@teetsh/app/src/containers/Demarrage/queries/key';
import { DemarrageData } from '@teetsh/app/src/containers/Demarrage/types';
import { requireUserSession } from '@teetsh/app/src/queries/requireUserSession';

function getDemarrage(): Promise<DemarrageData> {
  const requestURL = '/user/onboarding';
  return request(requestURL, {
    method: 'GET',
  });
}

function demarrageQuery() {
  return queryOptions({
    queryKey: [DEMARRAGE_KEY],
    queryFn: getDemarrage,
    staleTime: 10 * (60 * 1000), // 10 mins
    gcTime: 15 * (60 * 1000), // 15 mins
    refetchOnWindowFocus: false,
  });
}

export function useDemarrage() {
  return useQuery(demarrageQuery());
}

export const loader = (queryClient: QueryClient) => async () => {
  await requireUserSession();
  return queryClient.ensureQueryData(demarrageQuery());
};
